<script
  src="../../../../../../../Parcel/front-end/src/app/Parcel/customer-manage/customer-manage.component.ts"></script>
<div class="card card-box mb-5">
  <div class="card-header py-3">
    <div class="card-header--title font-size-lg">
      <b><i class="fas fa-cog"></i> Packages </b>
    </div>
    <div class="card-header--actions">
<!--      <button class="btn btn-sm btn-neutral-secondary" type="button" (click)="createModal()">-->
<!--                <span class="btn-wrapper&#45;&#45;icon">-->
<!--                    <fa-icon [icon]="['fas', 'plus-circle']" class="text-success"></fa-icon>-->
<!--                </span>-->
<!--        <span class="btn-wrapper&#45;&#45;label">-->
<!--                    New User-->
<!--                </span>-->
<!--      </button>-->
    </div>
  </div>
  <div class="d-flex justify-content-between px-4 py-3">
    <div class="search-wrapper">
          <span class="icon-wrapper text-black">
            <fa-icon [icon]="['fas', 'search']"></fa-icon>
          </span>
      <input class="form-control form-control-sm rounded-pill" placeholder="Search terms..." type="search">
    </div>
  </div>
  <div class="divider"></div>
  <div class="table-responsive">
    <table class="table table-hover text-nowrap mb-0">
      <thead>
      <tr>
        <th class="bg-white text-center">ID</th>
        <th class="bg-white text-center">PACKAGE NAME</th>
        <th class="bg-white text-center">TYPE</th>
        <th class="bg-white text-center">CATEGORY</th>
        <th class="bg-white text-center">PRICE</th>
        <th class="bg-white text-center">MODIFIED BY</th>
        <th class="bg-white text-center">ACTIONS</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let pac of packages">
        <td class="font-weight-bold text-center">
          # {{pac.id}}
        </td>
        <td class="font-weight-bold text-center">
          {{pac.packageName}}
        </td>
        <td class="font-weight-bold text-center">
          {{pac.travelType.type}}
        </td>
        <td class="font-weight-bold text-center">
          {{pac.packageCategory == null ? "N/A":pac.packageCategory.category}}
        </td>
        <td class="font-weight-bold text-center">
          {{pac.packagePrice}}
        </td>
        <td class="font-weight-bold text-center">
          {{pac.username}}
        </td>

        <td class="text-center">
          <div class="btn-group btn-group-sm m-2" role="group" aria-label="Basic example">
            <!--            <button type="button" class="btn btn-warning" (click)="userUpdate(user)"><i class="fas fa-upload"></i></button>-->
            <button type="button" class="btn btn-warning" (click)="update(pac)">
              <i class="fas fa-edit"></i>
            </button>
            <button type="button" class="btn btn-danger" (click)="packageDelete(errorModal,pac.id)"><i
              class="far fa-trash-alt"></i></button>
<!--            <button type="button" class="btn btn-success" (click)="packageUpdate(pac.id)" ><i class="fas fa-check-circle"></i></button>-->
          </div>
        </td>
      </tr>

      </tbody>
    </table>
  </div>

  <div class="card-footer py-3 d-flex justify-content-between">
    <pagination [totalItems]="totalRec" [(ngModel)]="currentPage" (pageChanged)="getallPackages($event.page)" class="pagination-icons pagination-warning"></pagination>
  </div>
</div>
<!--===========================delete Model===================================-->
<ng-template  #errorModal>
  <div class="text-center p-5">
    <div class="avatar-icon-wrapper rounded-circle m-0">
      <div
        class="d-inline-flex justify-content-center p-0 rounded-circle avatar-icon-wrapper bg-neutral-danger text-danger m-0 d-130">
        <fa-icon [icon]="['fas', 'times']" class="d-flex align-self-center display-3"></fa-icon>
      </div>
    </div>
    <h4 class="font-weight-bold mt-4">Are you sure you want to delete this entry?</h4>
    <p class="mb-0 font-size-lg text-muted">You cannot undo this operation.</p>
    <div class="pt-4">
      <button (click)="declineDelete()" class="btn btn-pill btn-neutral-secondary mx-1" type="button">
                <span class="btn-wrapper--label">
                    Cancel
                </span>
      </button>
      <button (click)="confirmDelete()" class="btn btn-pill btn-danger mx-1" type="button">
                <span class="btn-wrapper--label">
                    Delete
                </span>
      </button>
    </div>
  </div>
</ng-template>
<notifier-container></notifier-container>
